import Tween from "tween.ts";
import Animation from "./Animation";
import HTPEllipse from "../entities/howtoplay/secondPart/HTPEllipse";


export default class HTPEllipseShrinkAnimation extends Animation {
  constructor(ellipse: HTPEllipse, delay: number) {
    super();
    setTimeout(() => {
      new Tween.Tween(ellipse)
        .to({
          width: 130,
          height: 145
        }, 1000)
        .easing(Tween.Easing.Circular.Out)
        .yoyo(true)
        .repeat(Infinity)
        .start();
    }, delay);
  }
}